import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import _ from 'lodash';
import axios from 'axios';

//Query
import fetchSurveyById from '../../../queries/fetchSurveyById';
import fetchUser from '../../../queries/fetchUser';

// Components
import FieldCollection from './FieldCollection/';

// Icons
import TimeIco from 'react-icons/lib/md/timer';

class Survey extends Component {
	constructor(props) {
		super(props);
		this.handleSubmitSurvey = this.handleSubmitSurvey.bind(this);
	}
	resultsBuilder(answers) {
		const arr = [];
		_.mapKeys(answers, (value, key) => {
			arr.push({
				fieldCollectionId: key,
				answers: { ...value }
			});
		});
		return arr;
	}
	handleSubmitSurvey(childState) {
		const userId = this.props.fetchUser.user.id;
		const surveyId = this.props.fetchSurvey.surveyById.id;
		const results = this.resultsBuilder(childState);

		const payload = {
			userId,
			surveyId,
			results
		};

		axios
			.post('/survey/submit', payload)
			.then(res => {
				if (res.data.status === 'OK') {
					window.location.href = '/dashboard/encuestas';
				}
			})
			.catch(err => {
				console.log(err);
			});
	}
	render() {
		if (this.props.fetchUser.loading && this.props.fetchSurvey.loading) {
			return <div className="loader">Loading...</div>;
		}
		if (this.props.fetchSurvey.surveyById) {
			const {
				titulo,
				tiempo,
				descripcion,
				fieldcollection
			} = this.props.fetchSurvey.surveyById;
			return (
				<div className="container">
					<h1>{titulo}</h1>
					<div className="excerpt">{descripcion}</div>
					<div className="mb-4">
						<TimeIco /> Tiempo: {tiempo}
					</div>
					<FieldCollection
						fieldcollection={fieldcollection}
						handleSubmitSurvey={this.handleSubmitSurvey}
					/>
				</div>
			);
		}
		return null;
	}
}

export default compose(
	graphql(fetchUser, {
		name: 'fetchUser'
	}),
	graphql(fetchSurveyById, {
		name: 'fetchSurvey',
		options: props => {
			return { variables: { id: props.match.params.id } };
		}
	})
)(Survey);



// WEBPACK FOOTER //
// ./src/components/Survey/consumer/index.js